export default __webpack_public_path__ + "static/media/product2.686a5dd5.png";